/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
export var ApiExternalCreativeDataType;
(function (ApiExternalCreativeDataType) {
    ApiExternalCreativeDataType["EXTERNAL_CREATIVE_DATA_TYPE_UNSPECIFIED"] = "ExternalCreativeDataTypeUnspecified";
    ApiExternalCreativeDataType["EXTERNAL_CREATIVE_DATA_TYPE_TITLE"] = "ExternalCreativeDataTypeTitle";
    ApiExternalCreativeDataType["EXTERNAL_CREATIVE_DATA_TYPE_BODY"] = "ExternalCreativeDataTypeBody";
    ApiExternalCreativeDataType["EXTERNAL_CREATIVE_DATA_TYPE_DESCRIPTION"] = "ExternalCreativeDataTypeDescription";
    ApiExternalCreativeDataType["EXTERNAL_CREATIVE_DATA_TYPE_CALL_TO_ACTION"] = "ExternalCreativeDataTypeCallToAction";
    ApiExternalCreativeDataType["EXTERNAL_CREATIVE_DATA_TYPE_IMAGE_URL"] = "ExternalCreativeDataTypeImageURL";
})(ApiExternalCreativeDataType || (ApiExternalCreativeDataType = {}));
export function ApiExternalCreativeDataTypeFromJSON(json) {
    return ApiExternalCreativeDataTypeFromJSONTyped(json, false);
}
export function ApiExternalCreativeDataTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function ApiExternalCreativeDataTypeToJSON(value) {
    return value;
}
